module.exports = __webpack_public_path__ + "static/img/jj1.95605422.png";